/** Opens Razorpay Checkout for an order the server created and resolves with
 *  {razorpay_order_id, razorpay_payment_id, razorpay_signature}. When the
 *  order also sets up auto-pay (CUS-1) the server sends `customer_id` and
 *  `recurring`, which Checkout needs to register the mandate. */
export function payWithRazorpay(order, { user, description }) {
  if (typeof window.Razorpay !== "function") {
    return Promise.reject(new Error("The payment window couldn't load. Please check your connection and try again."));
  }
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: order.key_id,
      amount: order.amount,
      currency: order.currency,
      order_id: order.razorpay_order_id,
      ...(order.recurring ? { customer_id: order.customer_id, recurring: order.recurring } : {}),
      name: "PawBazaar",
      description,
      prefill: { name: user?.name || "", email: user?.email || "", contact: user?.phone || "" },
      theme: { color: "#ea9739" },
      handler: (res) => resolve({
        razorpay_order_id: res.razorpay_order_id,
        razorpay_payment_id: res.razorpay_payment_id,
        razorpay_signature: res.razorpay_signature,
      }),
      modal: { ondismiss: () => reject(new Error("Payment cancelled")) },
    });
    rzp.on("payment.failed", (resp) => reject(new Error(resp?.error?.description || "Payment failed")));
    rzp.open();
  });
}
